module.exports = __webpack_public_path__ + "f072b7e63d8cc16b226d86886160bff1.pdf";